import { AppConfig, AppSource, ProductionEnv, StageAppUrl, ProductionExternalUrl } from '@application/config';

export const environment: AppConfig = {
  appSource: AppSource.Afig,
  environment: 'local',
  apiUrl: ProductionEnv,
  externalUrl: ProductionExternalUrl,
  version: '1.0.0',
  appUrl: StageAppUrl
};
